import { PhotosReceiveGetByProfileIdReducer } from './types';

export const photosReceiveGetByProfileIdReducer: PhotosReceiveGetByProfileIdReducer =
  (state, action) => {
    return {
      ...state,
      currentProfilePhotos: action.payload,
    };
  };
